import { render, staticRenderFns } from "./ListPurchasesDeliveryPage.vue?vue&type=template&id=29a79219&"
import script from "./ListPurchasesDeliveryPage.vue?vue&type=script&lang=js&"
export * from "./ListPurchasesDeliveryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports